import Wix from './wix-sdk-polyfill';

export const showShare = () => {
  return Wix.Utils.getViewMode() !== 'editor' && Wix.Utils.getViewMode() !== 'preview';
};



// WEBPACK FOOTER //
// ./app/services/show-share.js